import * as React from "react"

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer"
import { useIsMobileShell } from "@/hooks/use-is-mobile-shell"

function ResponsiveModal(props: React.ComponentProps<typeof Dialog>) {
  const isMobile = useIsMobileShell()
  const Component = isMobile ? Drawer : Dialog
  return <Component {...props} />
}

function ResponsiveModalTrigger(props: React.ComponentProps<typeof DialogTrigger>) {
  const isMobile = useIsMobileShell()
  const Component = isMobile ? DrawerTrigger : DialogTrigger
  return <Component {...props} />
}

function ResponsiveModalContent(props: React.ComponentProps<typeof DialogContent>) {
  const isMobile = useIsMobileShell()
  const Component = isMobile ? DrawerContent : DialogContent
  return <Component {...props} />
}

function ResponsiveModalHeader(props: React.ComponentProps<typeof DialogHeader>) {
  const isMobile = useIsMobileShell()
  const Component = isMobile ? DrawerHeader : DialogHeader
  return <Component {...props} />
}

function ResponsiveModalTitle(props: React.ComponentProps<typeof DialogTitle>) {
  const isMobile = useIsMobileShell()
  const Component = isMobile ? DrawerTitle : DialogTitle
  return <Component {...props} />
}

function ResponsiveModalDescription(props: React.ComponentProps<typeof DialogDescription>) {
  const isMobile = useIsMobileShell()
  const Component = isMobile ? DrawerDescription : DialogDescription
  return <Component {...props} />
}

function ResponsiveModalFooter(props: React.ComponentProps<typeof DialogFooter>) {
  const isMobile = useIsMobileShell()
  const Component = isMobile ? DrawerFooter : DialogFooter
  return <Component {...props} />
}

export {
  ResponsiveModal,
  ResponsiveModalTrigger,
  ResponsiveModalContent,
  ResponsiveModalHeader,
  ResponsiveModalTitle,
  ResponsiveModalDescription,
  ResponsiveModalFooter,
}
